import { FormControl, FormControlLabel, RadioGroup, Radio } from "@mui/material";

const SelectionTypeGroup = ({ value,handleChange, disabled = false }) => {

  const controlProps = (item) => ({
    inputProps: { "aria-label": item },
  });

  const data = [{label: 'AND', value: 'AND'},{label: 'OR', value: 'OR'},{label: 'XAND', value: 'XAND'}]

  return (
    <>
    <div style={{ width: "100%" }}>
      <FormControl disabled={disabled} style={{ width: "100%" }}>
        <RadioGroup
          row
          aria-labelledby={"radio-group-horizontal"}
          name={"radio-group-horizontal"}
          value={value}
          onChange={(e) => {
            handleChange(e.target.value);
          }}
          style={{ width: "100%" }}
        >
          {data.map((item, idx) => (
            <FormControlLabel
              key={idx}
              value={item.value}
              sx={{
                m: 0,
                width: data.length <= 2 ? "60px" : `${100 / data.length}%`,
                height: "auto",
                display: "flex",
                justifyContent: "center",
                ...(item.value === value && {
                  backgroundColor: "#007842",
                  color: "white"
                }),
                borderRadius: `${idx === 0 && idx === data.length - 1
                  ? "12px 12px 12px 12px"
                  : idx === 0
                    ? "12px 0px 0px 12px"
                    : idx === data.length - 1 && "0px 12px 12px 0px"
                  }`,
                border: '1px solid rgba(0, 120, 66, 0.5)',
                '.MuiFormControlLabel-label': {
                  fontSize: 12
                },
              }}
              control={
                <Radio
                  {...controlProps({ label: item.label })}
                  sx={{
                    display: "none"
                  }}
                  className="select-type-group-radio"
                />
              }
              label={
                <div style={{ height: "auto", textAlign: "center"}}>
                 <strong>{item.label}</strong>
                </div>
              }
            />
          ))}
        </RadioGroup>
      </FormControl>
      </div>
    </>
  )
};

export default SelectionTypeGroup;
